const Setting = {
  urlApi: 'https://khohang.viettrungthong.net/api/web/',
  phone: '0908010630',
  phone1: '+8402835901595',
  fax: '+8402835901597',
  companyName: 'CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ SẢN XUẤT VIỆT TRUNG THÔNG',
  companyDescription: 'Chuyên cung cấp phụ kiện, thiết bị điện.',
  companyNameShort: 'Việt Trung Thông',
  companylat: '10.853325',
  companylng: '106.586777',
  web: 'viettrungthong.net',
  logo: '/images/logo/logo_donic.png',
  addressLocality: 'HOC MON',
  addressRegion: 'HCM',
  postalCode: '71713',
  addressCountry: 'VN',
  logo_white: '/images/logo/logo_donic_white.png',
  companyAddress: 'XTT9, 15/2 Tỉnh lộ 9, Tổ 2, Ấp 7, Xã Xuân Thới Thượng, H.Hóc Môn, TP HCM',
  companyNameVAT: 'CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ SẢN XUẤT VIỆT TRUNG THÔNG',
  companyAddressVAT: '15/2 Tỉnh lộ 9, Tổ 2, Ấp 7, Xã Xuân Thới Thượng, H.Hóc Môn, TP HCM',
  companyId: '0304464839',
  analyticsUA: 'UA-58186371-1',
  companyEmail: 'viettrungthong@gmail.com',
  chatFBappId: 'viettrungthong@gmail.com',
  chatFBpageId: 'viettrungthong@gmail.com',
  FB: 'viettrungthong@gmail.com',
  Twitter: 'viettrungthong@gmail.com',
  Linkedin: 'viettrungthong@gmail.com',
  GooglePlus: 'viettrungthong@gmail.com',
  Instagram: 'viettrungthong@gmail.com',
  Skype: 'viettrungthong@gmail.com',
  Zalo: 'viettrungthong@gmail.com',
  apiKeyMap: 'AIzaSyDyqZrJ5V54ZDrD24RbEUO0JXeJ1JsNEr0',
}
export default Setting



// WEBPACK FOOTER //
// ./src/containers/SettingContainer.js